import BaseApiService from './api.base.service'

class BlogSubscriptionsApiService extends BaseApiService {
  constructor() {
    super('blog')
  }

  getBlogSubscriptionsCountByUserId(userId, activeOnly = true) {
    let url = `/users/${userId}/subscriptions/count?activeOnly=${activeOnly}`
    return this.callGet(url)
  }

  getBlogSubscriptionsByUserId(userId, activeOnly = true) {
    let url = `/users/${userId}/subscriptions?activeOnly=${activeOnly}`
    return this.callGet(url)
  }

  deleteBlogSubscriptionByShopRigheTestataId(orderId) {
    return this.callPost(`/users/subscriptions/unsubscribe?orderId=${orderId}`)
  }

  async postBlogRegistrationRequest(data) {
    return await this.callPost('/registrations', data, {
      headers: { 'Content-Type': 'application/json' },
    })
      .then(res => res)
      .catch(err => {
        return {
          status: false,
          errorMessage: err,
        }
      })
  }

  getBlogRegistrationLocations() {
    return this.callGet(`/registers-professions`)
  }

  getBlogProvinces() {
    return this.callGet(`/provinces`)
  }

  getCheckTsIdExist(tsId, originBlog) {
    return this.callGet(`/registrations/form/check`, {
      tsId: tsId,
      blog: originBlog,
    })
  }

  getTsIdInfo(code) {
    return this.callGet(`/tsid`, { code: code })
  }

  getBlogUser(tsId, blogId) {
    return this.callPost(`/users/info`, { tsId: tsId, blogId: blogId })
  }

  getBlogData(id) {
    return this.callGet(`blogtoec/data/${id}`)
  }
}

export const blogSubscriptionsApi = new BlogSubscriptionsApiService()
